import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { AddonContext, CardContext, CellContext, forceMobile } from '../generics';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var ProductTableCellBase = function ProductTableCellBase(_ref) {
  var _ref$mobileOrder = _ref.mobileOrder,
      mobileOrder = _ref$mobileOrder === void 0 ? 2 : _ref$mobileOrder,
      _ref$extraRules = _ref.extraRules,
      extraRulesProp = _ref$extraRules === void 0 ? {} : _ref$extraRules,
      children = _ref.children,
      className = _ref.className;

  var _React$useContext = React.useContext(CellContext),
      gridColumnStart = _React$useContext.gridColumnStart,
      gridColumnSpan = _React$useContext.gridColumnSpan,
      gridRowStart = _React$useContext.gridRowStart,
      gridRowSpan = _React$useContext.gridRowSpan,
      accentCellCount = _React$useContext.accentCellCount,
      accentCellIndex = _React$useContext.accentCellIndex,
      firstInSplit = _React$useContext.firstInSplit,
      inFlexbox = _React$useContext.inFlexbox,
      inSplit = _React$useContext.inSplit,
      extraRulesCellContext = _React$useContext.extraRules;

  var _React$useContext2 = React.useContext(CardContext),
      isCard = _React$useContext2.isCard;

  var forcedMobile = forceMobile(isCard);

  var _React$useContext3 = React.useContext(AddonContext),
      order = _React$useContext3.order,
      extraRulesAddonContext = _React$useContext3.extraRules;

  var extraRules = _objectSpread(_objectSpread(_objectSpread({}, extraRulesCellContext), extraRulesAddonContext), extraRulesProp);

  var sx = _objectSpread({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginX: 8,
    // sm / 2
    paddingY: 6,
    // xs / 2
    order: order !== null && order !== void 0 ? order : forcedMobile([mobileOrder, null, 'initial'])
  }, extraRules);

  if (!inFlexbox) {
    Object.assign(sx, {
      gridColumn: forcedMobile([typeof accentCellIndex === 'number' && accentCellCount === 2 ? "".concat(accentCellIndex + 1, " / span 1") : '1 / -1', null, "".concat(gridColumnStart, " / span ").concat(gridColumnSpan)]),
      msGridColumn: "".concat(gridColumnStart),
      msGridColumnSpan: "".concat(gridColumnSpan),
      gridRow: forcedMobile(['initial', null, "".concat(gridRowStart, " / span ").concat(gridRowSpan)]),
      msGridRow: forcedMobile(['initial', null, "".concat(gridRowStart)]),
      msGridRowSpan: forcedMobile(['initial', null, "".concat(gridRowSpan)])
    });
  }

  if (inSplit) {
    sx['+ .in-split:not(.first-in-split)'] = {
      borderTop: '1px solid',
      variant: 'compounds.product-table.cellBase.variants.inSplit'
    };
  }

  return _jsx("div", {
    sx: sx,
    className: [inSplit ? 'in-split' : 'not-in-split', firstInSplit ? 'first-in-split' : 'not-first-in-split'].join(' '),
    children: _jsx("div", {
      sx: {
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 'auto',
        height: '100%',
        boxSizing: 'border-box'
      },
      className: className,
      children: children
    })
  });
};

export default ProductTableCellBase;
//# sourceMappingURL=cell-base.js.map